import { 
  doc, 
  collection,
  runTransaction,
  serverTimestamp,
  getDocs,
  query,
  orderBy
} from 'firebase/firestore';
import { db } from './firebase-config';
import { Visit } from '../types';
import { getCustomer } from './customers';

export const saveVisit = async (establishmentId: string, phone: string, visitData: Partial<Visit>): Promise<string> => {
  try {
    if (!establishmentId || !phone) {
      throw new Error('Dados inválidos para registrar visita');
    }

    const customer = await getCustomer(establishmentId, phone);
    if (!customer) {
      throw new Error('Cliente não encontrado');
    }

    const customerRef = doc(db, `establishments/${establishmentId}/customers/${customer.id}`);
    const visitsRef = collection(customerRef, 'visits');
    const visitDoc = doc(visitsRef);
    const visitId = visitDoc.id;
    
    await runTransaction(db, async (transaction) => {
      const customerDoc = await transaction.get(customerRef);
      if (!customerDoc.exists()) {
        throw new Error('Cliente não encontrado');
      }

      const customerData = customerDoc.data();
      if (customerData.establishmentId !== establishmentId) {
        throw new Error('Cliente não pertence a este estabelecimento');
      }

      const newTotalVisits = (customerData.totalVisits || 0) + 1;
      const newPoints = (customerData.points || 0) + (visitData.pointsEarned || 0);

      const newVisit = {
        ...visitData,
        id: visitId,
        establishmentId,
        timestamp: serverTimestamp(),
        visitNumber: newTotalVisits
      };

      transaction.set(visitDoc, newVisit);
      transaction.update(customerRef, {
        totalVisits: newTotalVisits,
        points: newPoints,
        lastVisit: visitData.date
      });
    });

    return visitId;
  } catch (error: any) {
    console.error('Save visit error:', error);
    throw new Error(error.message || 'Erro ao registrar visita');
  }
};

export const getCustomerVisits = async (establishmentId: string, phone: string): Promise<Visit[]> => {
  try {
    if (!establishmentId || !phone) {
      throw new Error('Dados inválidos para buscar visitas');
    }

    const customer = await getCustomer(establishmentId, phone);
    if (!customer) {
      throw new Error('Cliente não encontrado');
    }

    const visitsRef = collection(
      db, 
      `establishments/${establishmentId}/customers/${customer.id}/visits`
    );

    const visitsQuery = query(visitsRef, orderBy('timestamp', 'desc'));
    const snapshot = await getDocs(visitsQuery);
    
    return snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        ...data,
        id: doc.id,
        date: data.date,
        timestamp: data.timestamp?.toDate?.()?.toISOString() || data.timestamp
      } as Visit;
    });
  } catch (error: any) {
    console.error('Get customer visits error:', error);
    throw new Error(error.message || 'Erro ao buscar visitas');
  }
};